import React from "react";

// Keys match HouseholdStatus enum values; labels are human-facing.
const STATUS_CONFIG = {
  // --- Data Collection ---
  created:                    { bg: "bg-gray-100",    text: "text-gray-700",    label: "Created" },
  general_info_completed:     { bg: "bg-gray-100",    text: "text-gray-700",    label: "General Info Completed" },
  household_setup_initiated:  { bg: "bg-gray-100",    text: "text-gray-700",    label: "Household Setup Initiated" },
  draft:                      { bg: "bg-gray-100",    text: "text-gray-700",    label: "Draft" },
  active:                     { bg: "bg-emerald-50",  text: "text-emerald-800", label: "In progress" },
  in_progress:                { bg: "bg-emerald-50",  text: "text-emerald-800", label: "In progress" },
  shared_with_client:                  { bg: "bg-amber-50", text: "text-amber-800", label: "With Client" },
  shared_with_client_onboarding_done:  { bg: "bg-amber-50", text: "text-amber-800", label: "With Client" },
  shared_with_client_for_final_review: { bg: "bg-amber-50", text: "text-amber-800", label: "With Client" },
  pending_advisor_review:     { bg: "bg-violet-50",   text: "text-violet-700",  label: "Back with Advisor" },
  advisor_final_review:       { bg: "bg-violet-50",   text: "text-violet-700",  label: "Back with Advisor" },
  pending_form_download:      { bg: "bg-violet-50",   text: "text-violet-700",  label: "Pending Form Download" },
  data_collection_completed:  { bg: "bg-teal-50",     text: "text-teal-800",    label: "Data complete" },

  // --- Repapering ---
  forms_generated:            { bg: "bg-blue-50",     text: "text-blue-700",    label: "Forms Generated" },
  docusign_initiated:         { bg: "bg-blue-50",     text: "text-blue-700",    label: "Signature Execution · Envelope Created" },
  docusign_completed:         { bg: "bg-blue-100",    text: "text-blue-800",    label: "Signature Execution · Envelope Complete" },
  account_opened:             { bg: "bg-orange-50",   text: "text-orange-800",  label: "Account Opened" },
  toa_completed:              { bg: "bg-orange-100",  text: "text-orange-800",  label: "TOA Completed" },
  nigo:                       { bg: "bg-red-100",     text: "text-red-900",     label: "NIGO" },
  under_dispute:              { bg: "bg-yellow-100",  text: "text-yellow-900",  label: "Query Raised" },
  firm_paperwork_in_progress: { bg: "bg-violet-100",  text: "text-violet-800",  label: "Firm paperwork in progress" },

  // --- Terminal ---
  completed:                  { bg: "bg-emerald-100", text: "text-emerald-800", label: "Completed" },
  closed:                     { bg: "bg-gray-100",    text: "text-gray-700",    label: "Closed" },
  inactive:                   { bg: "bg-gray-100",    text: "text-gray-500",    label: "Inactive" },
};

const SUB_STATUS_LABELS = {
  pending_for_execution:   "Data complete · Pending for execution",
  hand_holding_required:   "Hand-Holding Required",
  client_editing:          "Client Editing",
  enriched:                "Enriched",
  docusign_envelope_created:  "Signature Execution · Envelope Created",
  docusign_envelope_sent:     "Signature Execution · Envelope Sent",
  docusign_envelope_complete: "Signature Execution · Envelope Complete",
  docusign_envelope_void:     "Signature Execution · Envelope Voided",
};

const FALLBACK_CONFIG = { bg: "bg-gray-100", text: "text-gray-700", label: "" };

export default function StatusBadge({ status, subStatus, staleHousehold = false, className = "" }) {
  void staleHousehold;

  const baseConfig = STATUS_CONFIG[status] || { ...FALLBACK_CONFIG, label: status || "—" };

  // Household sub_status is irrelevant when the household is NIGO — NIGO levels
  // now live on individual accounts, not the household.
  const effectiveSubStatus = status === "nigo" ? null : subStatus;
  const label =
    (effectiveSubStatus && SUB_STATUS_LABELS[effectiveSubStatus]) ||
    baseConfig.label;
  const nigoTag = null;

  return (
    <div className={`inline-flex items-center justify-center gap-1.5 flex-wrap ${className}`}>
      <span
        className={`inline-flex items-center justify-center px-2.5 py-0.5 rounded-full text-xs font-medium text-center ${baseConfig.bg} ${baseConfig.text}`}
      >
        {label}
      </span>
      {nigoTag && (
        <span className="inline-flex items-center justify-center px-2 py-0.5 rounded-full text-[10px] font-bold tracking-wide bg-red-700 text-white">
          {nigoTag}
        </span>
      )}
    </div>
  );
}
